import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ARInvoice } from '../../models/ar-invoice.model';

@Component({
    selector: 'app-paid-invoices',
    templateUrl: './paid-invoices.component.html',
    styleUrls: ['./paid-invoices.component.scss'],
    standalone: false
})
export class PaidInvoicesComponent {
  @Input() invoices: ARInvoice[] = [];
  @Output() selectedInvoiceRecordNo = new EventEmitter<string>();
  
  totalAmount = 0;
  currency = 'USD';

  displayedColumns: Array<keyof ARInvoice> = [
    'recordId', 'datePosted', 'datePaid', 'totalPaid'
  ];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['invoices']) {
      this.updateTotalAndCurrency();
    }
  }

  updateTotalAndCurrency() {
    this.totalAmount = (this.invoices ?? []).reduce((sum, i) => sum + (i?.totalPaid ?? 0), 0);
    this.currency = this.invoices?.length ? this.invoices[0].baseCurrency : 'USD';
  }

  viewInvoice(invoice: ARInvoice): void {
    this.selectedInvoiceRecordNo.emit(invoice.recordNo);
  }

  trackByFn = (_: number, row: any) => row.recordId;
}
